import { Component, Input } from '@angular/core';

@Component({
  selector: 'insert-edit-currency',
  templateUrl: './currency.component.html'
})
export class CurrencyComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;

  constructor() {}

}
